<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Error -->
    <div class="error">
      <div class="error__content">
        <h2>No permissions</h2>
        <h3>You have no permissions to view this subpage.</h3>
        <p>If it is an error - please contact with the system administrator.</p>
        <d-button pill @click="goBack">
          <i class="material-icons">arrow_back</i>
          Go back
        </d-button>
      </div>
    </div>
  </d-container>
</template>

<script>
export default {
  name: 'no-permissions',
  methods: {
    goBack() {
      window.history.go(-2);
    }
  }
}
</script>
